export default "__VITE_ASSET__DdqgLflf__"